export const BrandMark = ({ size = 36, className = "" }) => (
  <img src="/icon-192.png" alt="Basta10" width={size} height={size} className={`rounded-lg shrink-0 ${className}`} data-testid="brand-mark" />
);
